import { NumberFormatValues } from 'react-number-format';

export const DEFAULT_COLOR_HEX = '#000000';

// The backend's column lengths: an entry past them would fail the whole save.
export const NAME_MAX_LENGTH = 255;
export const VALUE_MAX_LENGTH = 255;
export const RANGE_UNIT_MAX_LENGTH = 32;

export const HEX_COLOR_PATTERN = /^#[0-9A-F]{6}$/i;

// The range columns are DECIMAL(15,4): at most 11 digits before the decimal point.
const RANGE_NUMBER_LIMIT = 1e11;

const isWithinRangeLimit = ({ floatValue }: NumberFormatValues) =>
  undefined === floatValue || Math.abs(floatValue) < RANGE_NUMBER_LIMIT;

// A range may sit below zero (e.g. a temperature).
export const RANGE_NUMBER_FORMAT = {
  allowNegative: true,
  decimalScale: 4,
  isAllowed: isWithinRangeLimit,
};

export const RANGE_INCREMENT_FORMAT = { decimalScale: 4, isAllowed: isWithinRangeLimit };
